export const menus = {
  system: [
    {
      name: 'Logout',
      icon: 'logout',
    },
  ],
  student: [
    {
      name: 'Home',
      icon: 'home',
      path: '/student',
      collapse: false,
    },
    {
      name: 'Courses',
      icon: 'courses',
      path: '/student/courses',
      collapse: false,
    },
    // {
    //   name: 'New Course',
    //   icon: 'courses',
    //   path: '/student/new-course',
    //   collapse: false,
    // },
    {
      name: 'Learning Tracker',
      icon: 'tracker',
      path: '/student/learning-tracker',
      collapse: false,
    },
    {
      name: 'Smart Quiz',
      icon: 'quiz',
      path: '/student/smart-quiz',
      collapse: false,
    },
    {
      name: 'New Smart Quiz',
      icon: 'quiz',
      path: '/student/new-smart-quiz',
      collapse: false,
    },
    {
      name: 'AI Tutor',
      icon: 'tutor',
      path: '/student/ai-tutor',
      collapse: false,
    },
    {
      name: 'Community',
      icon: 'community',
      path: '/student/communities',
      collapse: false,
    },
    {
      name: 'Messages',
      icon: 'messages',
      path: '/student/messages',
      collapse: false,
    },
  ],
  studentSystem: [
    {
      name: 'Settings',
      icon: 'settings',
      path: '/student/settings',
      collapse: false,
    },
  ],
  teacher: [
    {
      name: 'Home',
      icon: 'home',
      path: '/teacher',
      collapse: false,
    },
    {
      name: 'Courses',
      icon: 'courses',
      path: '/teacher/courses',
      collapse: false,
    },
    // {
    //   name: 'New Courses',
    //   icon: 'courses',
    //   path: '/teacher/new-courses',
    //   collapse: false,
    // },
    {
      name: 'AI Courseware',
      icon: 'aiCourseware',
      path: '/teacher/ai-courseware',
      collapse: false,
    },
    {
      name: 'Messages',
      icon: 'messages',
      path: '/teacher/messages',
      collapse: false,
    },
  ],
  teacherSystem: [
    {
      name: 'Settings',
      icon: 'settings',
      path: '/teacher/settings',
      collapse: false,
    },
  ],
  admin: [
    {
      name: 'Dashboard',
      icon: 'dashboard',
      path: '/admin',
      collapse: false,
    },
    {
      name: 'User',
      icon: 'users',
      path: '/admin/users',
      collapse: false,
    },
    {
      name: 'Course',
      icon: 'courses',
      path: '/admin/course',
      collapse: false,
    },
    {
      name: 'Messages',
      icon: 'messages',
      path: '/admin/messages',
      collapse: false,
    },
  ],
  adminSystem: [
    {
      name: 'Settings',
      icon: 'settings',
      path: '/admin/settings',
      collapse: false,
    },
  ],
};
